import { useState } from "react";
import { Button, Form, Row, Col, FloatingLabel, Spinner } from "react-bootstrap";
import { UserChangePasswordRequest } from "../../models/user";
import { LoginStore } from "../../stores/LoginStore";
import { useForm } from 'react-hook-form';
import _ from "lodash";
import { TFunction } from "i18next";

type Props = {
    t: TFunction;
    store: LoginStore;
}

const ChangePasswordForm: React.FC<Props> = ({ t, store }: Props) => {
    const { register, formState: {errors}, handleSubmit, getValues } = useForm();
    const [isLoading, setLoading] = useState(false);
    const [changeMessage, setChangeMessage] = useState('');
    const changePassword = async (data: UserChangePasswordRequest) => {
        setLoading(true);
        const res = await store.userChangePassword(data);
        if (res.status === 'OK') {
            setChangeMessage("Password aggiornata con successo");
        } else {
            setChangeMessage(res.message);
        }
        setLoading(false);
    }
    return (   
        <form className="registration-form" onSubmit={handleSubmit((data) => changePassword(data as UserChangePasswordRequest))}>
            <h3 className="text-center mb-3 gradient-title">{t("changePassword")}</h3>
            <FloatingLabel
                label="USERNAME"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('username', {
                        required: "Inserire una email o username validi",
                    })}
                    name="username"
                    type="text"
                    placeholder="Enter username" 
                    autoComplete="username"  
                />
                <p className="form-error">{_.toString(errors.username?.message)}</p>
                </>
            </FloatingLabel>   
            <FloatingLabel
                label="PASSWORD CORRENTE"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('password', {
                        required: "Campo obbligatorio"
                    })}
                    type="password" 
                    name="password"
                    placeholder="Password Corrente" 
                    autoComplete="password"
                />
                <p className="form-error">{_.toString(errors.password?.message)}</p>
                </>
            </FloatingLabel>
            <FloatingLabel
                label="NUOVA PASSWORD"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('newPassword', {
                        required: "Campo obbligatorio",
                        pattern: {
                            value: /^(?=.*[0-9])(?=.*[!@#$%^&*.,])[a-zA-Z0-9!@#$%^&*.,]{8,16}$/,
                            message: "La password deve contenere almeno 8 caratteri, 1 maiuscolo, 1 minuscolo, 1 numero ed 1 simbolo speciale"
                        }
                    })}
                    type="password" 
                    name="newPassword"
                    placeholder="Nuova Password" 
                    autoComplete="newPassword"
                />
                <p className="form-error">{_.toString(errors.newPassword?.message)}</p>
                </>
            </FloatingLabel>
            <FloatingLabel
                label="CONFERMA PASSWORD"
                className="mb-3"
            >
                <>
                <Form.Control 
                    {...register('confirmNewPassword', {
                        required: "Campo obbligatorio",
                        validate: (value) => value === getValues("newPassword") || 'Le password devono coincidere'
                    })}
                    type="password" 
                    name="confirmNewPassword"
                    placeholder="Conferma Password"
                />
                <p className="form-error">{_.toString(errors.confirmNewPassword?.message)}</p>
                </>
            </FloatingLabel>
            <Row className="mt-4">
                {changeMessage.length > 0 && (<Col md={12} className="text-center px-3 mb-1">
                    <p>{changeMessage}</p>
                </Col>)}
                <Col md={12} className="text-center px-3 mb-1">
                    <Button  type="submit" variant="primary" className="w-100" disabled={isLoading}>
                        {isLoading && <Spinner animation="grow" size="sm" />} {t("updatePassword")}
                    </Button>
                </Col>
            </Row>
        </form>
    );
}

export default ChangePasswordForm;